import { Box, Tooltip } from '@mui/material';
import { IconInfoRedesigned } from 'assets/img';
import { useTranslation } from 'react-i18next';

export const EmployeeContractRequestedInfoTooltip = () => {
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Tooltip title={t('employee-contract-requested-info', { ns: 'ogp-screen-specific' })}>
      <Box height={20} display="flex" alignItems="center">
        <IconInfoRedesigned data-testid="contract-requested-info" />
      </Box>
    </Tooltip>
  );
};
